import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { css } from 'styled-components';
import { colorBlue10, colorBlue20, colorGrey40, colorGrey80, colorGrey90 } from '../../../../tokens';
import { isStatusTag } from '../../../../components/Tag/utils';
import { TAG_DELETE_BEHAVIOUR_OPTIONS } from '../../../../components/Tag/constants';
export var getTagOverride = function getTagOverride(_ref) {
  var type = _ref.type,
      deleteOption = _ref.deleteOption,
      disabled = _ref.disabled;
  var result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        .Tag-CloseIconContainer {\n            color: ", ";\n            &:hover {\n                background-color: ", ";\n                color: ", ";\n            }\n        }\n\n        .Tag-Label {\n            color: ", ";\n        }\n    "])), colorGrey40, disabled ? 'transparent' : colorBlue10, disabled ? colorGrey40 : colorGrey90, colorBlue20);

  if (!isStatusTag(type)) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n            border-color: ", ";\n        "])), result, deleteOption === TAG_DELETE_BEHAVIOUR_OPTIONS.ON_HOVER ? 'transparent' : 'rgba(146, 186, 246, 0.2)', colorBlue20);
  } else {
    result = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            ", ";\n            .Tag-Label {\n                color: ", ";\n            }\n        "])), result, colorGrey80);
  }

  return result;
};